import {MaterialDesignContent} from "notistack";
import {styled} from "@mui/material/styles";

/**
 * Snackbar colours that meet WCAG 2.1 AA contrast (4.5:1) for the 14 px message text (DE-1724).
 * notistack's defaults don't: success #43a047 3.3:1, info #2196f3 3.1:1, warning #ff9800 2.2:1 with white text.
 * Error (#d32f2f, 5.0:1) and default (#313131) already pass and are left as they are.
 * Warning keeps its orange, with dark text: no orange reaches 4.5:1 with white.
 */
export const SNACKBAR_COLOURS = {
    success: {background: '#2e7d32', text: '#ffffff'},
    info: {background: '#0277bd', text: '#ffffff'},
    warning: {background: '#ff9800', text: '#212121'},
};

const AccessibleContent = styled(MaterialDesignContent)(() =>
    Object.fromEntries(Object.entries(SNACKBAR_COLOURS).map(([variant, {background, text}]) =>
        [`&.notistack-MuiContent-${variant}`, {backgroundColor: background, color: text}])));

/** For SnackbarProvider's Components prop. */
export const snackbarComponents = {
    success: AccessibleContent,
    info: AccessibleContent,
    warning: AccessibleContent,
};
